import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useKanbanBoardColumnStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 275,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',

            [theme.breakpoints.up('sm')]: {
                width: 373
            },
            [theme.breakpoints.down('xs')]: {
                borderRadius: 16,
                border: 'solid 1px #D4D4D4'
            }
        },
        collapsed: {
            alignSelf: 'flex-start'
        },
        header: {
            'gap': 12,
            'flexShrink': 0,
            'color': '#000',
            'display': 'flex',
            'padding': '12px 16px',
            'alignItems': 'flex-start',
            'justifyContent': 'space-between',

            [theme.breakpoints.down('xs')]: {
                flexWrap: 'wrap'
            },

            [theme.breakpoints.up('sm')]: {
                padding: '0 0 20px'
            },

            '& > svg': {
                order: 3,
                fontSize: 18,

                [theme.breakpoints.up('sm')]: {
                    display: 'none'
                }
            }
        },
        titleGroup: {
            order: 1,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginRight: 'auto',
            minWidth: 0
        },
        title: {
            gap: 8,
            width: '100%',
            margin: 0,
            color: '#000',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '26px',
            display: 'inline-flex',
            alignItems: 'center',

            [theme.breakpoints.down('xs')]: {
                flex: 1,
                justifyContent: 'space-between'
            }
        },
        titleText: {
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: '26px'
        },
        subtitle: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            marginTop: 8,
            color: '#7A7A7A',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '100%'
        },
        counter: {
            width: 26,
            height: 26,
            flexShrink: 0,
            boxSizing: 'border-box',
            color: '#FFF',
            textAlign: 'center',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '100%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000',
            borderRadius: '100%'
        },
        members: {
            'alignItems': 'center',
            'display': 'inline-flex',

            '&[data-clickable="true"]': {
                cursor: 'pointer'
            },

            '& img': {
                'width': 24,
                'height': 24,
                'objectFit': 'cover',
                'borderRadius': '100%',
                'border': 'solid 1px #ffffff',

                '&:not(:first-child)': {
                    marginLeft: -12
                }
            }
        },
        membersCount: {
            fontSize: 16,
            fontWeight: 500,
            marginLeft: 4
        },
        filter: {
            order: 5,

            [theme.breakpoints.down('xs')]: {
                width: '100%'
            },
            [theme.breakpoints.up('sm')]: {
                order: 2
            }
        },
        content: {
            'height': 584,
            'display': 'flex',
            'flexDirection': 'column',
            'flexShrink': 0,
            'padding': 0,
            'overflowX': 'hidden',
            'overflowY': 'auto',
            'scrollbarWidth': 'none',
            'msOverflowStyle': 'none',
            'transition': 'all 0.2s ease',

            '&::-webkit-scrollbar': {
                display: 'none'
            },

            [theme.breakpoints.up('sm')]: {
                borderRadius: 16,
                border: 'solid 1px #D4D4D4'
            },

            '& > *:not([data-row-id]):not([data-selection-bar])': {
                marginBlockStart: 8,
                marginBlockEnd: 8
            }
        },
        contentDropTarget: {
            backgroundColor: 'rgba(234, 180, 100, 0.05)',
            borderColor: '#EAB464',
            borderStyle: 'dashed',
            borderWidth: '1px',
            minHeight: '100px'
        }
    })
);
